import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 3.467a6.533 6.533 0 1 0 0 13.066 6.533 6.533 0 0 0 0-13.066M1.967 10a8.033 8.033 0 1 1 16.066 0 8.033 8.033 0 0 1-16.066 0"
      clipRule="evenodd"
    />
    <path d="M7.574 10.167a1.167 1.167 0 1 1-2.333 0 1.167 1.167 0 0 1 2.333 0m3.593 0a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0m3.593 0a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0Z" />
  </svg>
);
export default SvgPending;
